var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"into"},[_c('img',{staticClass:"into-icon",attrs:{"src":_vm.img,"alt":_vm.title}}),_c('h2',{staticClass:"into-title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }